const data = {
	statuses: ['', '未认证','个人认证', '企业认证', '个人认证审核中', '企业认证审核中', '已禁止', '', '', '', '审核中', ],
	ents: ['', '未认证','个人认证', '企业认证', '个人认证审核中', '企业认证审核中', '已禁止'],
	infoStatuses: ['全部', '待审', '已审', '拒审', '', '', '', '', '', '删除'],
	jobStatuses: ['全部', '待审', '已审', '拒审', '', '', '', '', '', '删除'],
	houseStatuses: ['全部', '待审', '已审', '拒审', '', '', '', '', '', '删除'],
	gender:['未知','男','女'],
	type:['','充值','消费']
}
export default {
	data
}